<template>
  <span>
    <a-popover placement="topLeft" v-if="isPopover">
      <template slot="content">
        <div style="width: 200px">
          <a-row v-for="(item, index) in popLists" :key="index">
            <a-col :span="8" style="text-align: right; font-weight: bold">{{ item.langType }}：</a-col>
            <a-col :span="16">{{ item.langText }}</a-col>
          </a-row>
        </div>
      </template>
      <span>{{ langText }}</span>
    </a-popover>
    <span v-else>{{ langText }}</span>
  </span>
</template>

<script>
export default {
  name: 'mtcHeader',
  props: {
    text: {
      type: String,
      default: ''
    },
    defaultTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      secondLanguage: JSON.parse(this.$ls.get('secondLanguage')) || []
    }
  },
  computed: {
    langText() {
      //先只改在线表单 目前先做兼容
      if(!this.defaultTitle){
        return this.$t(this.text) || this.text
      }
      return this.$getLanguageEnable() ? this.$t(this.text) || this.text : this.defaultTitle
    },
    popLists() {
      let secondLanguage = JSON.parse(this.$ls.get('secondLanguage')) || []
      let secondLabel = []
      if (!this.text) return
      secondLanguage.forEach(ele => {
        secondLabel.push({
          langType: ele,
          langText: this.$t(this.text, ele) || this.$t('tip.noData')
        })
      })
      return secondLabel
    },
    isPopover(){
       // 开启多语言 并且 有次语言
       return this.secondLanguage.length && this.$getLanguageEnable()
    }
  }
}
</script>

<style lang="less">
</style>